import {
    getLocationSite,
    setLocationSitePageSize,
    setLocationSiteColSearchStr,
    sortLocationSite,
    applyLocationSiteFilter,
    setLocationSiteFilter,
} from "../../../constants/model-reducers/external/inventory/circuit-details/locationsite.settings";
import { httpPost, httpDownload } from "../../../utils/api.utils";
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from "../../../constants/external-constants";
import { convertToFormatTimeZoneDate } from "../../../utils/helpers.utils";

const defaulstate = () => ({
    locationSite: DEFAULT_TABLE_RESULT_MODEL,
    locationSiteColSort: "",
    locationSiteIsSortedAsc: true,
    locationSiteFilterData: [],
    locationSiteFilterLoaded: false,
    locationSiteTableFilterList: [],
    locationSiteTableFilterApply: false,
    locationSiteId: {}
});

const initialState = defaulstate();

export const LocationSiteAction = {
    fetchLocationSite: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().locationSite.locationSite;
        const { locationSiteColSort, locationSiteIsSortedAsc, locationSiteTableFilterList, locationSiteTableFilterApply } = state().locationSite;
        var data = {
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes,
            },
            Eid: JSON.parse(sessionStorage.getItem("User")).Employee.EnterpriseId,
            UserId: sessionStorage.getItem("UserID"),
            EmployeeId: sessionStorage.getItem("EmployeeID"),
            Headers: pageUnmount? {} : { ...Headers },
            SortedColumnName: locationSiteColSort,
            IsSortAscending: locationSiteIsSortedAsc,
            TableFilterList: locationSiteTableFilterList,
            ApplyFilter: locationSiteTableFilterApply,
        };

        var result = await httpPost('external/inventory/getLocationSiteItems', data);
        dispatch({
            type: getLocationSite,
            payload: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL
        });
    },

    resizePageSize: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setLocationSitePageSize,
            payload: parseInt(pageSize)
        });
    },

    setLocationSiteColSearchStr: (event, key) => async (dispatch, state) => {
        const { locationSite } = state().locationSite;
        const val = event.target.value;
        const updatedLocationSite = {
            ...locationSite,
            Headers: {
                ...locationSite.Headers,
                [key]: {
                    ...locationSite.Headers[key],
                    searchString: val
                }
            }
        };
        dispatch({
            type: setLocationSiteColSearchStr,
            payload: updatedLocationSite
        });
    },

    setLocationSiteColSort: (isClick, isSortAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().locationSite.locationSite.Pagination;
        const { locationSiteTableFilterList, locationSiteTableFilterApply, locationSite } = state().locationSite;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: locationSite.Pagination.PerPage,
                PageSizes: PageSizes,
            },
            Eid: JSON.parse(sessionStorage.getItem("User")).Employee.EnterpriseId,
            UserId: sessionStorage.getItem("UserID"),
            EmployeeId: sessionStorage.getItem("EmployeeID"),
            Headers: { ...locationSite.Headers },
            SortedColumnName: isClick,
            IsSortAscending: isSortAsc,
            TableFilterList: locationSiteTableFilterList,
            ApplyFilter: locationSiteTableFilterApply,
        };

        var result = await httpPost('external/inventory/getLocationSiteItems', data);
        dispatch({
            type: sortLocationSite,
            payload: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL,
            locationSiteColSort: isClick,
            locationSiteIsSortedAsc: isSortAsc,
        });
    },

    applyLocationSiteFilter: (isApply) => (dispatch, state) => {
        const { locationSiteTableFilterList } = state().locationSite;
        dispatch({
            type: applyLocationSiteFilter,
            applyFilter: isApply,
            filterList: isApply ? locationSiteTableFilterList : [],
        });
    },

    addLocationSiteFilter: (tableFilter) => (dispatch, state) => {
        const { locationSiteTableFilterList } = state().locationSite;
        var filterList = [...locationSiteTableFilterList, tableFilter];
        dispatch({
            type: setLocationSiteFilter,
            filterList: filterList,
        });
    },

    removeLocationSiteFilter: (removeIndex) => (dispatch, state) => {
        const { locationSiteTableFilterList } = state().locationSite;
        var filterList = locationSiteTableFilterList.filter((item, index) => index !== removeIndex);
        dispatch({
            type: setLocationSiteFilter,
            filterList: filterList,
        });
    },

    extractLocationSite: () => async (dispatch, state) => {
        const { Headers } = state().locationSite.locationSite;
        const { locationSiteColSort, locationSiteIsSortedAsc, locationSiteTableFilterList, locationSiteTableFilterApply } = state().locationSite;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0
        ).replace(/[<>:"/\\|?*]/g, '-');

        var filename = `ATEM ${dealName} Location Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: { ...Headers },
            SortedColumnName: locationSiteColSort,
            IsSortAscending: locationSiteIsSortedAsc,
            FileName: filename,
            TableFilterList: locationSiteTableFilterList,
            ApplyFilter: locationSiteTableFilterApply,
        };

        httpDownload('external/inventory/getExtractLocationSite', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    saveInventoryLocationCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().locationSite.locationSite;
        const { locationSiteColSort, locationSiteIsSortedAsc, locationSiteTableFilterList, locationSiteTableFilterApply } = state().locationSite;

            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.LocationSiteInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes,
                },
                Eid: JSON.parse(sessionStorage.getItem("User")).Employee.EnterpriseId,
                UserId: sessionStorage.getItem("UserID"),
                EmployeeId: sessionStorage.getItem("EmployeeID"),
                Headers: { ...Headers },
                SortedColumnName: locationSiteColSort,
                IsSortAscending: locationSiteIsSortedAsc,
                TableFilterList: locationSiteTableFilterList,
                ApplyFilter: locationSiteTableFilterApply,
            };

            var result = await httpPost('external/inventory/getLocationSiteItems', data);

            dispatch({
                type: getLocationSite,
                payload: Object.keys(result).length > 0 ? result : DEFAULT_TABLE_RESULT_MODEL
            });

    },
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getLocationSite:
            return {
                ...state,
                locationSite: action.payload
            };
        case setLocationSitePageSize:
            return {
                ...state,
                locationSite: {
                    ...state.locationSite,
                    Pagination: {
                        ...state.locationSite.Pagination,
                        PerPage: action.payload
                    }
                }
            };
        case setLocationSiteColSearchStr:
            return {
                ...state,
                locationSite: action.payload
            };
        case sortLocationSite:
            return {
                ...state,
                locationSite: action.payload,
                locationSiteColSort: action.locationSiteColSort,
                locationSiteIsSortedAsc: action.locationSiteIsSortedAsc
            };
        case applyLocationSiteFilter:
            return {
                ...state,
                locationSiteTableFilterApply: action.applyFilter,
                locationSiteTableFilterList: action.filterList,
            };
        case setLocationSiteFilter:
            return {
                ...state,
                locationSiteTableFilterList: action.filterList,
            };
        default:
            return state;
    }
};